import { render, staticRenderFns } from "./EditorBlockOptions.vue?vue&type=template&id=01d3cc9a&scoped=true"
import script from "./EditorBlockOptions.vue?vue&type=script&lang=js"
export * from "./EditorBlockOptions.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockOptions.vue?vue&type=style&index=0&id=01d3cc9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3cc9a",
  null
  
)

export default component.exports